// @flow
import React, { type Node } from 'react';

import PlainTooltip from 'app/common/ui-next/plain-tooltip';

import styles from './Overflowed.scss';


type Props = {
  children: string,
}

const Overflowed = ({ children }: Props): Node => {
  return (
    <PlainTooltip
      text={children}
      className={styles.root}
      hideWithoutOverflow
    >
      {children}
    </PlainTooltip>
  );
};

export default Overflowed;
